var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPartialUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87541 3.11716C3.70691 2.94755 3.70691 2.67256 3.87541 2.50295C3.9737 2.40401 4.13306 2.40401 4.23136 2.50295L11.2791 9.59709C11.3774 9.69603 11.3774 9.85644 11.2791 9.95538C11.1106 10.125 10.8374 10.125 10.6689 9.95538L3.87541 3.11716Z",
    fill: "#84849A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.71135 4.28611C2.54285 4.1165 2.54285 3.84151 2.71135 3.6719C2.80964 3.57296 2.969 3.57296 3.06729 3.6719L10.115 10.766C10.2133 10.865 10.2133 11.0254 10.115 11.1243C9.94653 11.2939 9.67334 11.2939 9.50484 11.1243L2.71135 4.28611Z",
    fill: "#84849A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11233 2.19192C4.95105 2.03064 4.95105 1.76916 5.11233 1.60788C5.20641 1.5138 5.35894 1.5138 5.45302 1.60788L12.1987 8.35353C12.2927 8.44761 12.2927 8.60014 12.1987 8.69422C12.0374 8.8555 11.7759 8.8555 11.6146 8.69422L5.11233 2.19192Z",
    fill: "#84849A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05764 1.9158C6.89637 1.75452 6.89637 1.49304 7.05764 1.33176C7.15172 1.23768 7.30425 1.23768 7.39833 1.33176L12.476 6.40938C12.57 6.50346 12.57 6.65599 12.476 6.75007C12.3147 6.91135 12.0532 6.91135 11.8919 6.75007L7.05764 1.9158Z",
    fill: "#84849A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78421 5.52322C1.62293 5.36194 1.62293 5.10046 1.78421 4.93918C1.87829 4.8451 2.03082 4.8451 2.1249 4.93918L8.87054 11.6848C8.96462 11.7789 8.96462 11.9314 8.87054 12.0255C8.70926 12.1868 8.44778 12.1868 8.2865 12.0255L1.78421 5.52322Z",
    fill: "#84849A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.50296 7.46853C1.34168 7.30726 1.34168 7.04577 1.50296 6.88449C1.59704 6.79042 1.74957 6.79042 1.84365 6.88449L6.92127 11.9621C7.01534 12.0562 7.01534 12.2087 6.92127 12.3028C6.75999 12.4641 6.49851 12.4641 6.33723 12.3028L1.50296 7.46853Z",
    fill: "#84849A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.96 6.87788C11.96 4.10042 9.7054 1.84578 6.92793 1.84578C4.15047 1.84578 1.89583 4.10042 1.89583 6.87788C1.89583 9.65535 4.15047 11.91 6.92793 11.91V12.798L6.62325 12.7905C3.59767 12.6369 1.16895 10.2082 1.01533 7.18256L1.00781 6.87788C1.00781 3.60998 3.66003 0.957764 6.92793 0.957764L7.23261 0.965279C10.3591 1.12402 12.8481 3.71216 12.8481 6.87788L12.8405 7.18256C12.6818 10.3091 10.0937 12.798 6.92793 12.798V11.91C9.7054 11.91 11.96 9.65535 11.96 6.87788Z",
    fill: "#84849A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialUploadIcon);
export default __webpack_public_path__ + "static/media/partial-upload-icon.d2b7fa94.svg";
export { ForwardRef as ReactComponent };